import { useMemo } from "react";
import { TaskGrid } from "../../components/TaskGrid/TaskGrid";
import ViewTitle from "../../layout/components/ViewTitle";
import { useBoardViews } from "../../contexts/views/viewsContext";
import Enums from "../../types/enums";

export const RelatedToMe = () => {
  const { systemViews } = useBoardViews();

  const atmView = useMemo(
    () => systemViews.find((v) => v.ViewType === Enums.ViewType.RelatedToMe),
    [systemViews]
  );

  return (
    <>
      <div className="row">
        <ViewTitle viewId={atmView?.Id} viewName={atmView.Name} />
      </div>
      <div className="row">
        <TaskGrid viewId={atmView?.Id} />
      </div>
    </>
  );
};
